import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost, doPut } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const editPlaybookQuestions = createAsyncThunk(
  "updatePlaybookQuestion",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPut(urls?.editPlaybookQuestions, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addPlaybookQuestionsAction = createAsyncThunk("addPlaybookQuestions", async (arg, { rejectWithValue}) => {
    try {
      const response = await doPost(urls?.addPlaybookQuestions, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
}) 

export const editPlaybookQuestionsSlice = createSlice({
  name: "updatePlaybookQuestions",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    editPlaybookQuestionsReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [editPlaybookQuestions.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [editPlaybookQuestions.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.data = false;
    },
    [editPlaybookQuestions.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const addPlaybookQuestionsSlice = createSlice({
  name: "addPlaybookQuestions",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    addPlaybookQuestionsReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [addPlaybookQuestionsAction.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [addPlaybookQuestionsAction.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.data = false;
    },
    [addPlaybookQuestionsAction.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const { editPlaybookQuestionsReset } = editPlaybookQuestionsSlice.actions;
export const { addPlaybookQuestionsReset } = addPlaybookQuestionsSlice.actions;
